<script lang="ts">
  interface Props {
    value: number;
    max: number;
    /** How many blocks the bar is divided into. Discrete by design. */
    segments?: number;
    tone?: 'positive' | 'danger';
  }

  let { value, max, segments = 10, tone = 'positive' }: Props = $props();

  // Blocks, never a continuous fill: a smooth bar reads as a modern progress
  // indicator and breaks the arcade language on sight.
  const filled = $derived(
    max <= 0 ? 0 : Math.round((Math.min(Math.max(value, 0), max) / max) * segments),
  );
</script>

<div
  class="segbar {tone === 'danger' ? 'segbar--danger' : ''}"
  role="meter"
  aria-valuenow={value}
  aria-valuemin="0"
  aria-valuemax={max}
>
  {#each { length: segments } as _, index (index)}
    <span class="segbar__seg {index < filled ? 'segbar__seg--on' : ''}"></span>
  {/each}
</div>
